// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.management-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 15%;
  height: 100%;
  background-color: #1c1c1c;
  color: white;
}
@media (max-width: 768px) {
  .management-header {
    width: 100%;
    height: 55px;
    /* Adjust the height based on your design */
    z-index: 1001;
  }
}

.management-content {
  position: absolute;
  left: 15%;
  top: 0;
  width: 85%;
  height: 100%;
  background-color: #f5f5f5;
}
@media (max-width: 768px) {
  .management-content {
    left: 0;
    width: 100%;
    top: 55px;
    /* This should match the height of the .management-header */
    height: calc(100% - 55px);
    /* Adjust height to be full screen minus header */
  }
}

#create-vacation-btn {
  margin: 1% 2.5%;
  background-color: #1c1c1c;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  padding: 5px 10px;
}

.vacation-plan-container {
  width: 96%;
  height: 100%;
  background-color: #f5f5f5;
  padding: 0 2%;
}

.vacation-plan-item {
  border: 1px solid #ababab;
  background-color: white;
  border-radius: 8px;
  padding: 0.5rem;
  margin: 0.5rem;
}

.vacation-plan-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.4rem;
  font-size: 18px;
  font-weight: bold;
}

.vacation-plan-days {
  color: grey;
  font-size: 12px;
  display: flex;
  margin-left: auto;
  padding-right: 1rem;
}

.collapse-content {
  display: flex;
  flex-wrap: wrap;
  width: 100% !important;
}

.vacation-plan-summary {
  width: 13%;
  padding: 2%;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  margin: 1.5%;
}

.vacation-plan-summary-title {
  text-align: center;
  margin: 0;
  padding-bottom: 1.5rem;
}

.vacation-plan-summary-text {
  font-weight: bold;
}

@media (max-width: 768px) {
  .vacation-plan-summary {
    width: 100%;
  }
}
.content-hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/screens/management/styles/index.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AADJ;AAEI;EARJ;IASQ,WAAA;IACA,YAAA;IACA,2CAAA;IACA,aAAA;EACN;AACF;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AACJ;AAAI;EAPJ;IAQQ,OAAA;IACA,WAAA;IACA,SAAA;IACA,2DAAA;IACA,yBAAA;IACA,iDAAA;EAGN;AACF;;AAAA;EACI,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;AAGJ;;AAAA;EACI,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAGJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,eAAA;EACA,sBAAA;AAGJ;;AAAA;EACI,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,+CAAA;EACA,YAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,SAAA;EACA,sBAAA;AAGJ;;AAAA;EACI,iBAAA;AAGJ;;AACA;EACI;IACI,WAAA;EAEN;AACF;AAEA;EACI,aAAA;AAAJ","sourcesContent":["$mobile: 480px;\n$tablet: 768px;\n.management-header {\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 15%;\n    height: 100%;\n    background-color: #1c1c1c;\n    color: white;\n    @media (max-width: $tablet) {\n        width: 100%;\n        height: 55px;\n        /* Adjust the height based on your design */\n        z-index: 1001;\n    }\n}\n\n.management-content {\n    position: absolute;\n    left: 15%;\n    top: 0;\n    width: 85%;\n    height: 100%;\n    background-color: #f5f5f5;\n    @media (max-width: $tablet) {\n        left: 0;\n        width: 100%;\n        top: 55px;\n        /* This should match the height of the .management-header */\n        height: calc(100% - 55px);\n        /* Adjust height to be full screen minus header */\n    }\n}\n\n#create-vacation-btn {\n    margin: 1% 2.5%;\n    background-color: #1c1c1c;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 12px;\n    padding: 5px 10px;\n}\n\n.vacation-plan-container {\n    width: 96%;\n    height: 100%;\n    background-color: #f5f5f5;\n    padding: 0 2%;\n}\n\n.vacation-plan-item {\n    border: 1px solid #ababab;\n    background-color: white;\n    border-radius: 8px;\n    padding: 0.5rem;\n    margin: 0.5rem;\n}\n\n.vacation-plan-title {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding: 0.4rem;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.vacation-plan-days {\n    color: grey;\n    font-size: 12px;\n    display: flex;\n    margin-left: auto;\n    padding-right: 1rem;\n}\n\n.collapse-content {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100% !important;\n}\n\n.vacation-plan-summary {\n    width: 13%;\n    padding: 2%;\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);\n    margin: 1.5%;\n}\n\n.vacation-plan-summary-title {\n    text-align: center;\n    margin: 0;\n    padding-bottom: 1.5rem;\n}\n\n.vacation-plan-summary-text {\n    font-weight: bold;\n}\n\n// Responsive adjustments for management screen\n@media (max-width: $tablet) {\n    .vacation-plan-summary {\n        width: 100%;\n    }\n}\n\n// Hide content when mobile menu is open\n.content-hidden {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
